import { render, staticRenderFns } from "./yuanWenJieXi.vue?vue&type=template&id=94a5c7f6&scoped=true&"
import script from "./yuanWenJieXi.vue?vue&type=script&lang=js&"
export * from "./yuanWenJieXi.vue?vue&type=script&lang=js&"
import style0 from "./yuanWenJieXi.vue?vue&type=style&index=0&id=94a5c7f6&prod&lang=scss&"
import style1 from "./yuanWenJieXi.vue?vue&type=style&index=1&id=94a5c7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a5c7f6",
  null
  
)

export default component.exports